import React, {FC } from "react";
import {PromotionItem} from "../../models/promotionModel";

interface Props {
    promotion: PromotionItem
    entities: any
}
const PromotionCard: FC<Props> = ({ promotion, entities }) => {

    return (
        <div className="promotion-card">
            <div className={"text-section"}>
                <div className="company-section">
                    <div className="company-info">
                        <h2 className="company-name">{promotion.company_campaign.name}</h2>
                        <p className="company-description">
                            {promotion.company_campaign.description}
                        </p>
                    </div>
                    {promotion.company_campaign?.photo?.original_url && (
                        <img
                            className="company-avatar"
                            src={promotion.company_campaign.photo.original_url}
                            alt="company avatar"
                        />
                    )}
                </div>
                <div className="promotion-section">
                    {promotion?.photo?.original_url && (
                        <img
                            className="promotion-avatar"
                            src={promotion.photo.original_url}
                            alt="promotion avatar"
                        />
                    )}
                    <div className="promotion-info">
                        <h3 className="promotion-title">{promotion.title}</h3>
                        {/*<p>{startDate} - {endDate}</p>*/}
                        <p className="promotion-description">
                            {promotion.description}
                        </p>
                    </div>
                </div>
            </div>
            <div className="actions">
                <a
                    className="btn btn--green more-button"
                    type="button"
                    href={promotion?.company_campaign?.link_url}
                    target={"_blank"}
                >
                    {entities?.more_details?.value || "More details"}
                </a>
            </div>
        </div>
    )
}

export default PromotionCard;
